import { memo, useEffect, useState } from "react";
import MapUtils from "../utils/MapUtils";
import styled from "styled-components";

/**
 * KeyboardController there is no UI
 */
const KeyboardController = () => {
  const [isCtrlKPressed, setIsCtrlKPressed] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === '0' && event.ctrlKey) {
        MapUtils.zoomToDefaultView();
        setIsCtrlKPressed(false);
      } else if ((event.key === '-' || event.key === '_') && event.ctrlKey) {
        MapUtils.zoomOut();
        setIsCtrlKPressed(false);
      } else if ((event.key === '+' || event.key === '=') && event.ctrlKey) {
        MapUtils.zoomIn();
        setIsCtrlKPressed(false);
      }
    };
    if (isCtrlKPressed) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isCtrlKPressed]);


  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'k' && event.ctrlKey) {
        setIsCtrlKPressed(true);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return <>
    {isCtrlKPressed && <UI_Wrapper>Ctrl + K (đang lắng nghe)</UI_Wrapper>}
  </>
}

export default memo(KeyboardController);

const UI_Wrapper = styled.div`
  position: absolute;
  bottom: 8px;
  left: 8px;
  padding: 8px;
  width: 300px;
  height: 50px;
  border-radius: 8px;
  background-color: rgba(255,255,255, 0.8);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadows-paneShadow);
`;